module.exports = __webpack_public_path__ + "img/15.3db7994d.jpg";